import classNames from "classnames";
import PropTypes from "prop-types";
import { Suspense, useEffect, useRef } from "react";
import { Accordion, useAccordionButton } from "react-bootstrap";
import { Loading } from "..";
import classes from "./AccordionCard.module.scss";
import { useAccordionWizard } from "./AccordionProvider";

export const LoadingAccordion = () => {
  return (
    <div className="d-flex">
      <Loading />
      <span> Loading...</span>
    </div>
  );
};

export const AccordionCard = ({
  headerText,
  children,
  accordionKey,
  className,
  loading,
}) => {
  const ref = useRef();
  const eventKey = accordionKey || "0";
  const decoratedOnClick = useAccordionButton(eventKey);
  let Wrapper = Accordion;
  const accardionManager = useAccordionWizard();
  if (accardionManager) Wrapper = "div";
  useEffect(() => {
    if (accardionManager) {
      /**
       * register accordion tab on the accordion provider
       * so then, the next/toStep methods can ba handled
       */
      accardionManager.register(eventKey, ref.current);
    }
  }, [accardionManager, eventKey]); //eslint-disable-line

  const handleOnClick = () => {
    if (!loading) return decoratedOnClick();
  };
  const isOpen =
    accardionManager && accardionManager.activeEventKey === eventKey;
  return (
    <Wrapper className={classNames("w-100", className)}>
      <div
        className={classes["main-wrapper"]}
        ref={ref}
        // TODO: this line makes it non-general
        style={{ scrollMargin: "200px" }}
      >
        <div onClick={handleOnClick} className={classes["header"]}>
          <div className={classes["header-text"]}>{headerText}</div>
          {loading ? (
            <Loading dark />
          ) : (
            <div
              className={classNames(`toggle-icon icon-down-dir`, {
                "rotate-0": isOpen,
                "rotate-180": !isOpen,
              })}
            />
          )}
        </div>
        <Accordion.Collapse eventKey={eventKey}>
          <Suspense fallback={<LoadingAccordion />}>
            <div className={classes["body"]}>{children}</div>
          </Suspense>
        </Accordion.Collapse>
      </div>
    </Wrapper>
  );
};

AccordionCard.propTypes = {
  /**
   * string to be shown at the header of accordion
   */
  headerText: PropTypes.string,
  /**
   * Any node to be shown inside the accordion view
   */
  children: PropTypes.node,
};

AccordionCard.defaultProps = {
  headerText: undefined,
  children: undefined,
};
